require('string-format');

// var SceneManager = require('./scene-manager').SceneManager;
import {LoadScene} from './loadscene';
import {PopupScene} from './popupscene';
import Init from './init';
import SETTINGS from "settings";
import Space from './frp/space'
import PIXI_video_performance_fix from "PIXI_video_performance_fix"
import own_version_info from "../version"
import Server$ from "./network/net";
import ErrorDriver from "./error";

import uiConfigDefaultXGA from "./cfg/userinterface-config"
import uiConfigDefaultSVGA from "./cfg/userinterface-config_800x600"
import uiMobileConfigDefaultSVGA from "./cfg/userinterface_mobile-config_800x600";
import uiMobileConfigDefaultXGA from "./cfg/userinterface_mobile-config";

import Server from "./network/network_api";
import { cookies } from "./network/request"
import { Image, UrlParamsToObject, in_iframe, get_prop, canFullscreen, canScreenLock, is_fullscreen } from "utils"
import load from 'load'
//Sounds не используется но нужно для того чтобы инициализировалась глобальная переменная:
import Sounds from 'sounds'
import bundles from 'bundles'

import ears, { ear_url } from 'ears'

import {NoSleep} from './vendor/my_no_sleep'

const url_params = UrlParamsToObject()

const hand_url = 'res/common/mobile/tapToFullscreen.png'
const swapHand_url = 'res/common/mobile/swapToFullscreen.png'

const runInIOS = ( !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) ) //&& (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/));
const need_fullscreen = (canFullscreen() || runInIOS) && url_params[ 'fullscreen' ] == 1

let stage
let ears_container
let game_container
let popupScene
let uiAdaptiveContainer

export const SCREEN_RATIO_1 = 16 / 9
export const SCREEN_RATIO_2 = 4 / 3

let $ticker_seconds

SETTINGS.preserve_resource_format = SETTINGS.preserve_resource_format || []
SETTINGS.preserve_resource_format.push(
    'common/new_ui/userinterface_1024x768_new',
    'common/new_ui/jp_panel_font',
    ear_url,
    hand_url,
    swapHand_url
)

const COMMON_HOWLER_RESOURCES = [
        'res/common/sounds/clock_tick',
    ];


function getUserInterfaceResources(config, mobile) {

    if ( SETTINGS.user_interface ) return SETTINGS.user_interface;

    if (mobile) {
        const mobileFonts = [
            'res/common/mobile/fonts/ui_mobile_main_font.xml',
            'res/common/mobile/fonts/ui_mobile_panel_font.xml',
            'res/common/mobile/fonts/ui_mobile_win_font.xml',
            'res/common/mobile/fonts/mjp_bronze_font.xml',
            'res/common/mobile/fonts/mjp_green_font.xml',
            'res/common/mobile/fonts/mjp_gold_font.xml',
            'res/common/mobile/fonts/mjp_white_font.xml',
        ];
        switch (config.resolution.width) {
            default:
            case 1024:
                return mobileFonts.concat(['res/common/mobile/ui_mobile_1024x768_0.json', 'res/common/mobile/ui_mobile_1024x768_1.json', 'res/common/mobile/menu_panel.jpg']);
            case 800:
                return mobileFonts.concat(['res/common/mobile/ui_mobile_1024x768_0.json', 'res/common/mobile/ui_mobile_1024x768_1.json', 'res/common/mobile/menu_panel.jpg']);
        }
    }

    switch ( config.resolution.width ) {
        default:
        case 1024:
            return [
                'res/common/new_ui/userinterface_1024x768_new.json',
                'res/common/new_ui/userinterface1024x768-font.xml',
                'res/common/new_ui/userinterface1024x768_win-font.xml',
                'res/common/new_ui/jp_panel_font.xml',
            ]
        case 800:
            return [
                'res/common/new_ui/userinterface_800x600_new.json',
                'res/common/new_ui/userinterface800x600-font.xml',
                'res/common/new_ui/userinterface800x600_win-font.xml',
                'res/common/new_ui/jp_panel_font_800x600.xml',
            ]
    }
    
}

// prevent context menu on production
// it is the only place the jQuery included on
if (NODE_ENV == "production") {
    $(document).on("contextmenu", function (event) { event.preventDefault(); });
}

/** Растянуть игру на весь экран с сохранением пропорций и отцентровать.*/
function fit( width, height, ratio, screen_config ) {
    //change the ratio of the canvas based on current window size to resize it:
    let w, h;

    if ( width / height >= ratio ) {
        w = height * ratio
        h = height
    }
    else {
        w = width
        h = width / ratio
    }

    game_container.scale.set(
        w / screen_config.resolution.width,
        h / screen_config.resolution.height
    )

    //центровка:
    game_container.x = ( width - w ) / 2
    game_container.y = ( height - h ) / 2

    if (SETTINGS.isMobile && uiAdaptiveContainer) {
        uiAdaptiveContainer.x = 0;
        uiAdaptiveContainer.y = ( height - h ) / 2
        uiAdaptiveContainer.scale.set(
            width / 1024,
            h / 768
        );
    }

    return { x : w, y : h }
}

/** Растянуть игру на весь экран БЕЗ сохранений пропорций, занимая всё доступное пространство.*/
function stretch( width, height ) {
    //пока что рефакторится использование PIXI в HTML, обойдёмся без stretch() - всё-равно никто не помнит как он должен работать и для чего делался (да и акцент сейчас на мобилки где stretch()'а быть не должно):
    return { x : width, y : height }
}

function initScreen( screenConfig, space ) {

    PIXI.renderer = PIXI.autoDetectRenderer(
        SETTINGS.canvas.width,
        SETTINGS.canvas.height,
        {
            antialias : false,
            transparent : false,
            resolution: window.devicePixelRatio || 1,
            autoResize:true,
            //может уменьшить разрывы между текстурами при скейлинге основного контейнера с игрой
            roundPixels: SETTINGS.roundPixels || false,
            //trying to fix flickering on android devices:
            preserveDrawingBuffer : true,
            backgroundColor : 0x011B22,
        }
    );
    PIXI.renderer.plugins.interaction.autoPreventDefault = true// false

    stage = new PIXI.Container

    no_sleep( stage )

    ears_container = new PIXI.Container
    stage.addChild( ears_container )

    game_container = new PIXI.Container
    stage.addChild( game_container )
    space.s( 'screen_ratio' ).next( SCREEN_RATIO_1 )
    console.log( 'canvas:', SETTINGS.canvas, 'resolution:', screenConfig.resolution )

    const maskGameContainer = new PIXI.Graphics();
    maskGameContainer.beginFill(0xFFFFFF);
    maskGameContainer.drawRect(0, 0, screenConfig.resolution.width, screenConfig.resolution.height);
    maskGameContainer.endFill();
    game_container.addChild(maskGameContainer);
    game_container.mask = maskGameContainer;

    document.body.insertBefore(PIXI.renderer.view, document.body.firstChild);

    if (SETTINGS.isMobile) {

        const compareHeightValue = () => {
            if (window.innerWidth > window.innerHeight) {
                return Math.min(window.screen.availWidth, window.screen.availHeight);
            }
            else {
                return Math.max(window.screen.availWidth, window.screen.availHeight);
            }
        }

        uiAdaptiveContainer = new PIXI.Container();
        uiAdaptiveContainer.interactive = true;
        stage.addChild( uiAdaptiveContainer )

        const docEl = window.document.documentElement;

        let when_hide_tap
        const hand = Image( hand_url )
        const swapHand = Image(swapHand_url);
        const do_tap = new PIXI.Container;
        const do_tap_background = new PIXI.Graphics;

        const resizeHand = (width, height) => {
            let scale = 1;
            let scaleSwap = 1;
            if (width > height) {
                scale = (0.4*width)/219
                scaleSwap = (0.3*width)/219
            }
            else {
                scale = (0.45*height)/224
                scaleSwap = (0.35*height)/224
            }
            hand.scale.set(scale);
            hand.position.x = width / 2 - hand.width / 2
            hand.position.y = height / 2 - hand.height / 2

            swapHand.scale.set(scaleSwap);
            if (swapHand.height > height) {swapHand.height = height}
            swapHand.position.x = width / 2 - swapHand.width / 2
            swapHand.position.y = height / 2 - swapHand.height / 2

            if ( do_tap.visible ) {
                do_tap_background.clear()
                do_tap_background.beginFill(0x000000, 0.85)
                do_tap_background.drawRect(0, 0, window.innerWidth, window.innerHeight)
                do_tap_background.endFill()
            }
        }

        const $showTapScreen = space.s('show_tap_screen');

        if ( need_fullscreen )
        {

            //чёрная заглушка экрана с изображением руки, требующая игрока тапнуть по экрану чтобы экран повернулся и перешёл в fullscreen:
            stage.addChild( do_tap )
            do_tap.interactive = true
            do_tap.tap = () => {
                hand.visible = false;
                space.s( 'try_toggle_fullscreen' ).next();
            }
            // const do_tap_background = new PIXI.Graphics
            // $ticker_seconds.on( () => {
            //     if ( ! do_tap.visible ) return
            //     do_tap_background.clear()
            //     do_tap_background.beginFill( 0x000000, 0.85 )
            //     do_tap_background.drawRect( 0, 0, window.innerWidth, window.innerHeight )
            //     do_tap_background.endFill()
            // } )
            do_tap.addChild( do_tap_background )

            do_tap.addChild( hand )
            do_tap.addChild(swapHand);

            swapHand.visible = runInIOS;
            hand.visible = !runInIOS;


            space.s( 'change_screen' ).on( screen => {
                let w = screen.w;
                let h = screen.h;

                // if ( ! do_tap.visible ) return
                // do_tap_background.clear()
                // do_tap_background.beginFill( 0x000000, 0.85 )
                // do_tap_background.drawRect( 0, 0, w, h )
                // do_tap_background.endFill()

                space.s( 'change_to_vertical' ).next((h > w))
            } )

            space.s( 'change_to_vertical' )
                .distinctUntilChanged()
                .withLatestFrom(space.s( 'change_screen' ), (_, screen) => screen)
                .on(screen => {
                    resizeHand(screen.w, screen.h);
                })

            space.s( 'change_screen' )
                .any( space.s( 'landscape' ), space.s( 'need_fullscreen' ), ( _1, _2, nf ) => nf )
                .on( nf => {

                    if (runInIOS) {
                        if (nf && (window.innerHeight + 50) < compareHeightValue()) {
                            window.scrollTo(0, 0);
                            when_hide_tap = undefined
                            do_tap.alpha = 1
                            do_tap.visible = true
                            swapHand.visible = true
                            PIXI.renderer.plugins.interaction.autoPreventDefault = false;
                            resizeHand(window.innerWidth, window.innerHeight);
                            $showTapScreen.next(true);
                        }
                        else {
                            PIXI.renderer.plugins.interaction.autoPreventDefault = true;
                            do_tap.visible = false;
                            swapHand.visible = false;
                            $showTapScreen.next(false);
                        }
                    }
                    else {
                        if (is_fullscreen()) {
                            when_hide_tap = new Date;
                            hand.visible = false;
                            $showTapScreen.next(false);
                        }
                        else {

                            when_hide_tap = undefined

                            if (nf) {
                                resizeHand(window.innerWidth, window.innerHeight);
                                do_tap.alpha = 1;
                                do_tap.visible = true;
                                hand.visible = true;
                                $showTapScreen.next(true);
                            }
                        }
                    }

                } )
            
            space.s( 'ticker' )
                .on( () => {
                    if ( when_hide_tap ) {
                        const GAP = 500
                        const alpha = ( GAP - ( ( new Date ) - when_hide_tap ) ) / GAP
                        do_tap.alpha = Math.max( alpha, 0 )
                        if ( alpha <= 0 ) {
                            when_hide_tap = undefined
                            if ( is_fullscreen() ) {
                                do_tap.visible = false
                                space.s( 'screen_change' ).next()
                            }
                        }
                    }
                } )

            space.s('goToLobby').on(() => {
                do_tap.visible = true;
                do_tap.alpha = 1;
                hand.visible = false;
                swapHand.visible = false;
            })
        }

        if (runInIOS && need_fullscreen) {

            docEl.style.height = '300%';
            docEl.style.position = 'static';
            window.scrollTo(0, 0);
            if (window.innerHeight < compareHeightValue()) {
                PIXI.renderer.plugins.interaction.autoPreventDefault = false;
                do_tap.visible = true;
                swapHand.visible = true;
                $showTapScreen.next(true);
            }

            window.onscroll =  () =>  {

                let scroll = window.pageYOffset || document.documentElement.scrollTop;
                if ((window.innerHeight + 50) >= compareHeightValue() && scroll >= 40 ) {
                    PIXI.renderer.plugins.interaction.autoPreventDefault = true;
                    do_tap.visible = false;
                    swapHand.visible = false;
                    $showTapScreen.next(false);
                    //window.scrollTo(0, 0);
                }
            }
        }

    }

    const $screen_change = space.s( 'screen_change' )
    window.addEventListener( 'resize', () => $screen_change.next() );
    window.addEventListener( 'orientationchange', () => $screen_change.next() )
    setInterval( () => $screen_change.next(), 100 )

    space.s( 'need_fullscreen' ).to($screen_change)
    space.s( 'screen_ratio' ).to( $screen_change )
    
    space.s( 'landscape' ).next( canScreenLock() && ! url_params[ 'no_orientation_lock' ] )

    let w
    let h
    let o
    let r

    // видимо нам иногда понадобится отключать ресайз
    const $need_resize = space.s('need_resize');
    $need_resize.next(true)

    $screen_change
        .with( space.s( 'landscape' ), space.s( 'screen_ratio' ), $need_resize, ( _, landscape, screen_ratio, need_resize ) => ({ landscape, screen_ratio, need_resize }) )
        .filter(({need_resize}) => need_resize || w !== window.innerWidth)
        .do( ({ landscape }) => {
            //you can attempt locking orientation ONLY when it's in fullscreen:
            if ( landscape && is_fullscreen() ) {
                try {
                    const promise = window.screen.orientation.lock('landscape')
                    promise.catch(() => {})
                } catch (e) {}
            }
        } )
        .map( ({ screen_ratio}) => ({
            w : window.innerWidth,
            h : window.innerHeight,
            o : window.orientation || 0,
            r : screen_ratio,
        }) )
        .filter( new_screen => new_screen.w != w || new_screen.h != h || new_screen.o != o || new_screen.r != r )
        .do( new_screen => {
            if (runInIOS && (w === new_screen.w) && (o === new_screen.o) && (new_screen.h < h)) {
                r = new_screen.r
            }
            else {
                w = new_screen.w
                h = new_screen.h
                o = new_screen.o
                r = new_screen.r
            }

            PIXI.renderer.resize( w, h )
        } )
        .map( () => ({ w, h, o }) )
        .to( space.s( 'change_screen' ) )

    const $fit_or_stretch = space.s( 'change_screen' ).map( ({ w, h, o }) => {
        let do_stretch = (STRETCH_ENV !== 'false' && !SETTINGS.isMobile);

        //пока что рефакторится использование PIXI в HTML, обойдёмся без stretch() - всё-равно никто не помнит как он должен работать и для чего делался (да и акцент сейчас на мобилки где stretch()'а быть не должно):
        do_stretch = false

        //дизайнерское требование запретить растягивать игру по вертикали больше чем по горизонтали:
        // if ( w / h < config.resolution.width / config.resolution.height) {
        if ( w / h < SETTINGS.canvas.width / SETTINGS.canvas.height ) {
            do_stretch = false;
        }
        return ({ do_stretch, w, h, o })
    } )
    $fit_or_stretch
        .filter( ({ do_stretch }) => do_stretch )
        .map( ({ w, h }) => stretch( w, h ) )
        .to( space.s( 'resize' ) )
    $fit_or_stretch
        .filter( ({ do_stretch }) => ! do_stretch )
        .with( space.s( 'screen_ratio' ), ( { w, h }, screen_ratio ) => ({ w, h, screen_ratio }) )
        .map( ({ w, h, screen_ratio }) => fit( w, h, screen_ratio, screenConfig ) )
        .to( space.s( 'resize' ) )
    
    $screen_change.next( true )
    
    //unlock orientation when user doesn't want it:
    space.s( 'landscape' )
        .filter( landscape => ! landscape )
        .on( () => window.screen.orientation.unlock() )
}

function animate() {
    requestAnimationFrame( animate )
    try
    {
        PIXI.renderer.render( stage )
    }
    catch ( e )
    {
        console.error( 'PIXI render fail:', e )
    }
}

function InitFullScreenSettings( space ) {

    if (SETTINGS.isMobile)
    {
        space.s( 'need_fullscreen' ).next( need_fullscreen )
        
        const $try_toggle_fullscreen = space.s( 'try_toggle_fullscreen' )

        //when user clicks "fullscreen" button it now means changing screen ratio:
        $try_toggle_fullscreen
            .with( space.s( 'need_fullscreen' ), ( _, need_fullscreen ) => need_fullscreen )
            .filter( need_fullscreen => need_fullscreen )
            .on(() => {

                console.log("TRY ENTER FULL!!!!!!!", is_fullscreen())

                const docEl = window.document.documentElement;

                const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen;

                if (!is_fullscreen()) {
                    requestFullScreen.call(docEl)
                }
            })

        //if comment
        //when user clicks "fullscreen" button it now means changing screen ratio:
        //enter fullscreen when user clicks the button:
        space.s( 'need_fullscreen' )
            .filter( need_fullscreen => need_fullscreen )
            .to( $try_toggle_fullscreen )
        
        //exit fullscreen when user clicks the button:
        space.s( 'need_fullscreen' )
            .filter( need_fullscreen => ! need_fullscreen )
            .on( () => {
                console.log( 'EXITING FULLSCREEN' )
                const doc = window.document
                const cancelFullScreen = doc.exitFullscreen || doc.webkitExitFullscreen || doc.mozCancelFullScreen || doc.msExitFullscreen
                cancelFullScreen.call(doc);
            } )
    }
    else {

        const fullScreenButton = document.createElement('img');
        fullScreenButton.src = "../common/zoom_in.png";
        fullScreenButton.className = 'fullscreenbutton';
        document.body.appendChild(fullScreenButton);

        //this fullscreen mode detection method may not work:
        var isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
        var mouseover = false

        /** Updates button's representation accordingly current display mode.*/
        function handleChange() {
            if (isFullscreen) {
                fullScreenButton.src = mouseover ? '../common/zoom_out_over.png' : "../common/zoom_out.png";
            }
            else {
                fullScreenButton.src = mouseover ? '../common/zoom_in_over.png' : "../common/zoom_in.png";
            }
        }

        $( fullScreenButton ).mouseover( () => {
            mouseover = true;
            handleChange();
        } );
        $( fullScreenButton ).mouseout( () => {
            mouseover = false;
            handleChange();
        } );

        //it seems like there is some possibility that game may be started already with fullscreen mode on:
        handleChange();

        BigScreen.onenter = function () {
            isFullscreen = true;
            handleChange();
        };
        BigScreen.onexit = function () {
            isFullscreen = false;
            handleChange();
        }

        //BigScreen still can't handle Firefox, so let's help it:
        document.addEventListener("mozfullscreenchange", function () {
            isFullscreen = document.mozFullScreen;
            handleChange();
        }, false);

        fullScreenButton.addEventListener('click', function () {
            //если просто toggle(), то для document.body, что приходит к исчезновению background'а:
            BigScreen.toggle(document.documentElement);
        }, false);
    }
}

let ga_server_reported = false
let ga_graphics_reported = false
let ga_load_reported = false

module.exports.main = function(
    resources,
    construct,
    serverInfo,
    serverOptions,
    uiConfig,
    screenConfig,
    versionInfo,
    uiMobileConfig,
    params,
)
{
    clearTimeout( get_back_timeout )

    SETTINGS.serverOptions = serverOptions
    SETTINGS.versionInfo = versionInfo

    SETTINGS.volume = SETTINGS.hasOwnProperty( 'volume' ) ? SETTINGS.volume : 0.5
    Howler.volume( SETTINGS.volume )

    bundles()

    PIXI.loaders.Resource.setExtensionLoadType( 'jp2', PIXI.loaders.Resource.LOAD_TYPE.IMAGE )
    PIXI.loaders.Resource.setExtensionXhrType( 'jp2', PIXI.loaders.Resource.XHR_RESPONSE_TYPE.BLOB )
    
    const space = new Space( 'main' )

    tab_visibility( space )

    SETTINGS.isMobile = MobileEsp.DetectTierIphone() || MobileEsp.DetectTierTablet();
    SETTINGS.isTablet = MobileEsp.DetectTierTablet();
    
    ga_event( 'main' );
    ga_timing( 'main' )

    $ticker_seconds = ticker( space )

    InitFullScreenSettings( space )
    
    PIXI_video_performance_fix()
    
    SETTINGS.screen = screenConfig;
    SETTINGS.canvas = SETTINGS.canvas || { width : 1366, height : 768 };

    const server = new Server(
        serverInfo.gameNetworkId,
        serverInfo.gameName || "UNDEFINED",
        serverInfo.bonusUserSelectionsPolicy,
        serverInfo.totalizator
    );

    cancelCaching( versionInfo );

    // window.onerror = function myErrorHandler( messageOrEvent, source, lineno, colno, error ) {
    //     var failure = "Something failed: " + messageOrEvent + " at " + source + ", line " + lineno + ", column " + colno + ". Error: " + JSON.stringify( error );
    //     console.error(failure);
    //     server.printTalks();
    // };
    if ( SETTINGS.isMobile ) {
        //window.onerror = ( message_or_event, source, lineno, colno, error ) => console.error( message_or_event, source, lineno, colno, error )
        window.onerror = ( message_or_event, source, lineno, colno, error ) => {
            const txt = message_or_event +'|'+ source +'|'+ lineno +'|'+ colno +'|'+ error
            
            if ( NODE_ENV == 'development' && serverInfo.gameName != 'vendor' ) alert( txt )
            
            server && server.trace && server.trace( txt )
        }
    }

    initLog();

    if ( versionInfo ) console.log( versionInfo.name + " build: " + versionInfo.build + " buildDate: " + versionInfo.buildDate )
    else console.log( 'versionInfo is undefined' )

    load( space.child( 'load' ), trans_url )

    space.s( 'load:complete' )
        .filter( c => c.bundle && c.bundle.name == 'loadscreen' )
        .on( () => boot( {
            resources,
            construct,
            serverOptions,
            uiConfig,
            screenConfig,
            uiMobileConfig,
            space,
            server,
            params
        } ) )

    space.s( 'load:postpone_sounds' ).next( SETTINGS.isMobile )

    // первоначальная загрузка элементов загрузочного экрана и служебных картинок
    const LOADSCREEN_RESOURCES = [
        'res/common/load_process_indicator.json',
        'res/common/no_connection.json',
        'res/common/connection_failed.png',
        
    
        'res/common/progressive_jackpot/jp_ingame_panel.png',
        'res/common/progressive_jackpot/fonts/jp_bronze_font.xml',
        'res/common/progressive_jackpot/fonts/jp_green_font.xml',
        'res/common/progressive_jackpot/fonts/jp_white_font.xml',
        'res/common/progressive_jackpot/fonts/jp_gold_font.xml',
    
        'res/common/progressive_jackpot/jp_money_panel.png',
        'res/common/progressive_jackpot/fonts/jp_money_font.xml',
        'res/common/progressive_jackpot/fonts/jp_currency_font.xml',



        screenConfig.loadscreen.image || 'res/loadscreen.jpg',
        screenConfig.loadscreen.loadbar.image || 'res/loadbar.png',

        ear_url,

        'res/common/mobile/tapToFullscreen.png',
        'res/common/mobile/swapToFullscreen.png',
    ]
    space.s( 'load:load' ).next( {
        name : 'loadscreen',
        graphics : LOADSCREEN_RESOURCES
    } )
}

function boot( {
    resources,
    construct,
    serverOptions,
    uiConfig,
    screenConfig,
    uiMobileConfig,
    space,
    server,
    params,
} )
{
    initScreen( screenConfig, space )

    ears( space, ears_container )

    //попробуем прокрутить страницу вверх, если это возможно
    // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // if (!in_iframe() && scrollTop && scrollTop > 0) {
    //     window.scrollTo(0, 0);
    // }

    let loadScene = new LoadScene(screenConfig);
    game_container.addChild( loadScene )

    if ( in_iframe() ) window.top.postMessage( "game_loading_begin", "*" )

    popupScene = new PopupScene(screenConfig);
    game_container.addChild( popupScene )

    popupScene.showProcessIndicator();
    
    const server$ = Server$( server );
    const errorDriver = ErrorDriver(
        popupScene,
        server$,
        serverOptions,
        server.lobbyURL,
        server.$error,
    )
    
    const onFatal = ( message, instant, redirectUrl ) => {
        server && server.trace && server.trace( message )
        
        if ( ! ga_server_reported )
        {
            ga_server_reported = true
            ga(
                'send',
                'exception',
                {
                    exDescription : message,
                    exFatal : true
                }
            )
        }
    }

    //initialize server connection:
    const invokeHandleLobby = () => server.handleLobby(
        () => {

            console.log( 'Server communication successfully established.' )

            if ( ! ga_server_reported )
            {
                ga_server_reported = true
                ga_event( 'server_connected' );
            }
            
            popupScene.hideNoConnectionBanner();
            loadScene.hideConnectionIndicator();
            
            server_connected = true
            try_complete()
        },
        error => {
            
            if ( ! ga_server_reported )
            {
                ga_server_reported = true
                ga(
                    'send',
                    'exception',
                    {
                        exDescription : error,
                        exFatal : false
                    }
                )
            }
            
            console.error( 'Failed to handle lobby: ' + error );
            popupScene.showNoConnectionBanner();
            popupScene.hideProcessIndicator();

            invokeHandleLobby();
        },
        onFatal,
        serverOptions
    );
    invokeHandleLobby();
    
    space.s( 'load:error' ).on( msg => onFatal(
        msg,
        false,
        ( ! url_params[ 'nolobby' ] ) ?
            (url_params['lobby_url']) ?
                decodeURIComponent( url_params['lobby_url'] )
                :
                decodeURIComponent( cookies.get( 'lobby_url' ) )
            :
            undefined
    ) )

    space.s( 'load:progress' ).on( progress => loadScene && loadScene.updateProgress( progress ) )

    fix_loading_stuck( space )

    space.s( 'load:complete' )
        .filter( c => c.bundle && c.bundle.name == 'main' )
        .on( c => {
            if ( ! ga_graphics_reported )
            {
                ga_graphics_reported = true
                ga_event( 'graphics_loaded' );
            }

            graphics_loaded = true
            try_complete()
        } )

    let graphics_loaded = false
    let server_connected = false
    const try_complete = () => {
        if ( graphics_loaded && server_connected ) {

            //adding resources of current stage so that engine may start working right away:
            const adding = SETTINGS.bundles.filter( b => b.types.some( t => t == server.type ) )
            if ( adding.length > 0 ) {
                console.log( 'Preloading', adding, 'resources for stationed state ...' )
                added = true
                space.s( 'load:load' ).next( adding )
            }
            else {
                complete()
            }
        }
    }

    const complete = () => {
        if ( ! ga_load_reported )
        {
            ga_load_reported = true
            ga_event( 'main_completed' );
            ga_timing( 'main_completed' )
        }
        
        popupScene.hideProcessIndicator();
        loadScene.hideConnectionIndicator();
        loadScene.parent.removeChild( loadScene )
        loadScene.destroy(true);
        loadScene = null;

        if ( in_iframe() ) window.top.postMessage( "game_loading_end", "*" )

        if ( ! SETTINGS.ui_config ) {
            if ( SETTINGS.isMobile ) {
                SETTINGS.ui_config = ( SETTINGS.screen.resolution.width == 1024 ) ? uiMobileConfigDefaultXGA : uiMobileConfigDefaultSVGA
            }
            else {
                SETTINGS.ui_config = ( SETTINGS.screen.resolution.width == 1024 ) ? uiConfigDefaultXGA : uiConfigDefaultSVGA
            }
        }

        if ( params && params.static_control ) params.static_control()

        Init({
            server,
            construct,
            rootContainer : game_container,
            errorView : popupScene,
            uiConfig : SETTINGS.ui_config,
            parent : space,
            uiRootContainer : uiAdaptiveContainer,
            $tickerSeconds : $ticker_seconds,
            server$,
            errorDriver,
        })
    }

    let added = false
    space.s( 'load:complete' )
        .filter( () => added )
        .do( () => added = false )
        .on( complete )


    space.s( 'load:load' ).next( {
        name : 'main',
        graphics : getUserInterfaceResources( screenConfig, SETTINGS.isMobile ).concat( resources.pixi ),
        sounds : COMMON_HOWLER_RESOURCES.concat(resources.howler),
    } )

    animate();
}

/** iPhone has some bug which causes first time page loading (in case of heavy resources) to stuck without any errors; trying to fix (considering it stuck if can't load 0.1% of resources in 10 seconds) */
function fix_loading_stuck( space )
{
    if ( ! runInIOS ) return

    let loading = false
    let stuck_progress = 0
    let stuck_time
    space.s( 'load:load' ).on( () => {
        loading = true
        stuck_progress = 0
        stuck_time = undefined
    })
    space.s( 'load:progress' ).on( progress => {
        loading = true
        const progress_time = performance.now()
        //if first progress or normal progress:
        if ( ! stuck_time || Math.abs( progress - stuck_progress ) > 0.001 )
        {
            stuck_time = progress_time
            stuck_progress = progress
        }
    })
    space.s( 'load:complete' ).on( () => {
        loading = false
        stuck_progress = 0
        stuck_time = undefined
    })
    setInterval(
        () => {
            if ( ! loading ) return

            const now = performance.now()
            if ( stuck_time && ( now - stuck_time ) > ( 30 * 1000 ) )
            {
                window.location.reload( true )
            }
        },
        1000
    )
}

function initLog()
{
    var htmlElement = document.getElementById('log');

    if (HTMLLOG_ENV && NODE_ENV === 'development') {
        var oldLog = console.log;
        var oldError = console.error;

        var logger = function () {
            
            let append = '-------------------------------------<br />'
            
            for (var i = 0; i < arguments.length; i++) {
                if (typeof arguments[i] == 'object') {
                    //avoid "... cercular structure ..." error:
                    try {
                        append += (JSON && JSON.stringify ? JSON.stringify(arguments[i], undefined, 2) : arguments[i]) + ' ';
                    } catch(e){
                        append += 'some cercular structure was here' + ' '
                    }
                } else {
                    append += arguments[i] + ' ';
                }
            }
            
            htmlElement.innerHTML = append + '<br />' + htmlElement.innerHTML
        };

        console.log = function()
        {
            logger.apply( this, arguments );
            oldLog.apply( this, arguments );
        };
        console.error = function()
        {
            logger.apply( this, arguments );
            oldError.apply( this, arguments );
        };
    }
    else {
        if (htmlElement && htmlElement.parentNode) {
            htmlElement.parentNode.removeChild(htmlElement);
        }
    }
}

function redirect( to )
{
    window.location.replace( to );
}

function cancelCaching()
{
    if ( ! own_version_info || ! own_version_info.build )
    {
        console.error( "NO BUILD INFORMATION" )
    }
    
    //cannot yet implement it for PIXI V3:
    if ( PIXI.version == 3 ) return
    
    var originalAdd = PIXI.loader.add;
    PIXI.loader.add = function()
    {
        //throughout the project resources are referenced the same way they're loaded so when we alter the URL to cancel caching they can't be referenced anymore (only sole ones - those without json wrappers), but PIXI allows specifying name separately from path so we define our own args:
        const newArgs = Array.prototype.slice.call( arguments );
        switch ( arguments.length )
        {
            case 1:
                const arg = arguments[ 0 ]
                if ( typeof arg === 'string' )
                {
                    newArgs[ 1 ] = trans_url( arg )
                }
                //no need to handle array since I know (it's not defined by API :( ) that PIXI just calls this function again with all the array values one-by-one ...
                else if ( Array.isArray( arg ) ) {}
                //our custom animation batch:
                else
                {
                    const arr = []
                    for ( let i = 0; i < arg.count; ++ i )
                    {
                        arr.push( arg.path.$( i ) )
                    }
                    newArgs[ 0 ] = arr
                    console.log( 'custom to', arg )
                }
                break;

            //that's how PIXI loads resources parsed out from .json files:
            case 4:
                newArgs[ 1 ] = trans_url( arguments[ 1 ] );
                break;

            default:
                console.warn( 'PIXI: Unknown resources load spec.', arguments );
                break;
        }

        return originalAdd.apply( PIXI.loader, newArgs );
    };
}

let url_settings

function need_reformat( URL )
{
    if ( SETTINGS.preserve_resource_format_for_all ) return false

    //все интерфейсы пусть без сжатия:
    if (
        ( URL.indexOf( '800' ) >= 0 && URL.indexOf( '600' ) >= 0 )
        ||
        ( URL.indexOf( '1024' ) >= 0 && URL.indexOf( '768' ) >= 0 )
    )
    {
        return false
    }

    return ! SETTINGS.preserve_resource_format.some( f => URL.indexOf( f ) >= 0 || f.indexOf( URL ) >= 0 )
}

/** Cancel URL caching, redirect common resources and determin resources type.*/
function trans_url( URL )
{
    //resources redirection based on OS/browser:
    if ( need_reformat( URL ) )
    {
        if ( ! url_settings )
        {
            url_settings = {}
            
            //if Chrome browser:
            if ( /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) )
            {
                url_settings.webp = true
                //Chrome webp doesn't work on iOS:
                if ( !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) )
                {
                    url_settings.webp = false
                }
            }
            //if Safari browser:
            else if ( !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) )
            {
                url_settings.jp2 = true
            }
        }
        
        if ( url_settings.webp )
        {
            if ( URL.endsWith( '.png' ) )
            {
                URL = URL.substring( 0, URL.length - 3 ) + 'webp'
            }
        }
        else if ( url_settings.jp2 )
        {
            if ( URL.endsWith( '.png' ) )
            {
                URL = URL.substring( 0, URL.length - 3 ) + 'jp2'
            }
        }
    }
    
    
    if ( URL.indexOf( '?' ) >= 0 ) return URL
    
    const normal_cache = own_version_info ? encodeURI( own_version_info.build ) : ( new Date() ).getTime()
    
    
    //ресурсы из pixi json файлов уже имеют нужный путь:
    if ( URL.startsWith( common_path() ) )
    {
        return URL + '?' + common_cache
    }
    
    const t = 'res/common/'
    if ( URL.indexOf( t ) == 0 )
    {
        return common_path() + URL.substring( t.length ) + '?' + common_cache
    }
    
    return URL + '?' + normal_cache
}

function ticker( space ) {
    const $tickerSeconds = space.s( "ticker" )
    let lastTime = Date.now()
    TweenMax.ticker.addEventListener('tick', function(event)  {
        TWEEN.update(performance.now());
        
        const now = Date.now();
        const dt = now - lastTime;
        
        lastTime = now;
        $tickerSeconds.next( dt / 1000 );
    })
    return $tickerSeconds
}

function no_sleep( stage )
{
    const ns = new NoSleep
    stage.interactive = true
    const enable = () => {
        console.log( 'Enabling NoSleep with PIXI event ...' )
        ns.enable()
        stage.off( 'pointerdown', enable )
    }
    stage.on( 'pointerdown', enable )
}

function tab_visibility( space )
{
    const $tab_visibility = space.s( 'tab_visibility' )
    $tab_visibility.next( true )
    document.addEventListener(
        'visibilitychange',
        () => $tab_visibility.next( document.visibilityState != 'hidden' )
    )
}






// WEBPACK FOOTER //
// ./src/library/boot.es6